import { Globe, Mail, Phone } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-white py-10">
      <div className="container-base grid gap-8 text-sm text-slate-600 md:grid-cols-3 md:items-start">
        <div className="flex justify-center md:justify-start">
          <a href="#inicio" aria-label="+Trainer Inicio">
            <img src="/navbar_logo.png" alt="+Trainer" className="h-10 w-auto" />
          </a>
        </div>

        <div className="text-center md:text-left">
          <div className="mt-3 flex items-center justify-center gap-4 md:justify-start">
            <a
              href="https://www.facebook.com/profile.php?id=61552425156573"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="rounded-full p-2 text-slate-500 transition-colors hover:bg-brand-50 hover:text-brand-600"
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
                <path d="M13.5 8.5V6.75c0-.48.32-.75.75-.75H16V3h-2.25C11.96 3 10.5 4.46 10.5 6.25V8.5H8.25v3h2.25V21h3v-9.5H16l.5-3h-3z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/mastrainerapp.com_/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="rounded-full p-2 text-slate-500 transition-colors hover:bg-brand-50 hover:text-brand-600"
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden="true">
                <rect x="3.5" y="3.5" width="17" height="17" rx="5" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
                <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
              </svg>
            </a>
            <a
              href="https://mastrainerapp.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Web +Trainer"
              className="rounded-full p-2 text-slate-500 transition-colors hover:bg-brand-50 hover:text-brand-600"
            >
              <Globe className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div className="text-center md:text-left">
          <h3 className="font-semibold text-ink">Contacto</h3>
          <div className="mt-3 space-y-3">
            <a
              href="tel:+5493512392367"
              className="inline-flex items-center gap-3 transition-colors hover:text-brand-600"
            >
              <Phone className="h-4 w-4" />
              <span>+5493512392367</span>
            </a>
            <a
              href="mailto:hola@mastrainerapp.com"
              className="inline-flex items-center gap-3 transition-colors hover:text-brand-600"
            >
              <Mail className="h-4 w-4" />
              <span>hola@mastrainerapp.com</span>
            </a>
          </div>
        </div>
      </div>

      <div className="container-base mt-8 border-t border-slate-100 pt-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} +Trainer. Todos los derechos reservados.
      </div>
    </footer>
  );
}
